import { render, staticRenderFns } from "./editFoucusStrategy.vue?vue&type=template&id=4950ce2c&"
import script from "./editFoucusStrategy.vue?vue&type=script&lang=js&"
export * from "./editFoucusStrategy.vue?vue&type=script&lang=js&"
import style0 from "./editFoucusStrategy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports